import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { PedidosNaoAtendidosComponent } from './pedidos-nao-atendidos/pedidos-nao-atendidos.component';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { MonitorComponent } from './monitor/monitor.component';
import { MonitorItemComponent } from './monitor/monitor-item';
import { MonitorProdutoComponent } from './monitor/monitor-produto'
import { ControlsModule } from '../controls/controls.module';
import { ComentariosListComponent } from './fila-de-pedidos/comentarios-list';
import { MonitorPedidoComponent } from './monitor/monitor-pedido.component';
import { ViewsModule } from '../views/views.module'

export const routes: Routes = [
  { path: 'monitor', component: MonitorComponent, data: { breadcrumb: 'Monitor' } },
  { path: 'naoAtendidos/:full', component: PedidosNaoAtendidosComponent },
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule, ReactiveFormsModule,
    SharedModule,
    ViewsModule,
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,  // <- comment this line for activate lazy load
      // useHash: true
    }),
    ControlsModule,
  ],
  declarations: [
    PedidosNaoAtendidosComponent,
    MonitorComponent,
    MonitorItemComponent,
    MonitorProdutoComponent,
    ComentariosListComponent,
    MonitorPedidoComponent
  ],
  exports: [
    PedidosNaoAtendidosComponent,
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]

})
export class FollowupModule { }
